export function HomePage () {
  return (
    <div>
      <h1 className='heading-lg mb-6'>Home</h1>
    </div>
  )
}
